/**
 * 公共备案信息 API（前台消费者）
 *
 * 对接 `/api/public/landing/filing` 公开读接口（后端 PublicFilingInfoDto），
 * 仅返回页脚法定展示所需的 ICP 备案号、公安备案号与公司全称。
 *
 * 修复配置审查#11（P0）：首页页脚此前调用管理端 `getFilingInfo()`（走
 * `/api/admin/system-config/filing`，需 admin:config:read），匿名访客必 401/403，
 * 错误被 `.catch()` 静默吞掉 → 备案号对公众恒空；而后端专门准备的这个公开端点零调用方。
 * 公开页因此只走本服务，管理端表单继续走 admin 端点取完整字段。
 */
import { httpGet } from '@/utils/httpClient'
import type { PublicFilingInfo } from '@/types/system-config'

export const publicFilingHttpService = {
  /**
   * 获取公开备案信息。
   * 公共读接口失败时不向用户抛出技术错误，返回 null 由页脚降级为不显示备案号。
   */
  async getFilingInfo(): Promise<PublicFilingInfo | null> {
    try {
      const data = await httpGet<PublicFilingInfo>('/api/public/landing/filing')
      return data ?? null
    } catch (e) {
      console.error('[publicFilingHttp] failed to load filing info:', e)
      return null
    }
  },
}
